var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconStoreReviews(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke:#000;stroke-linecap:round;stroke-miterlimit:10;stroke-width:25px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ICON") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_2",
    "data-name": "Artboard 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M845.49,540.41H232.91a11.43,11.43,0,0,1-10-16.89L302.58,376.8a11.45,11.45,0,0,1,10.05-6H765.76a11.45,11.45,0,0,1,10,6l79.72,146.72A11.43,11.43,0,0,1,845.49,540.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M846,598.59H235.81a6.77,6.77,0,0,0-6.78,6.77v431.45a6.77,6.77,0,0,0,6.78,6.77H463.29V897.09a45.93,45.93,0,0,1,45.93-45.93h63.19a45.93,45.93,0,0,1,45.93,45.93v146.49H846a6.78,6.78,0,0,0,6.78-6.77V605.36A6.78,6.78,0,0,0,846,598.59Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 172.96,
    y: 540.41,
    width: 735.89,
    height: 103.88,
    rx: 4.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M815.13,93.38l23,70.65a5.84,5.84,0,0,0,5.57,4.05H918a5.86,5.86,0,0,1,3.45,10.6l-60.11,43.67a5.87,5.87,0,0,0-2.13,6.55l23,70.66a5.86,5.86,0,0,1-9,6.55L813,262.44a5.87,5.87,0,0,0-6.89,0L746,306.11a5.86,5.86,0,0,1-9-6.55l23-70.66a5.85,5.85,0,0,0-2.12-6.55l-60.11-43.67a5.86,5.86,0,0,1,3.45-10.6h74.29A5.84,5.84,0,0,0,781,164l23-70.65A5.86,5.86,0,0,1,815.13,93.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M542.55,40.47l23,70.65a5.84,5.84,0,0,0,5.57,4h74.29a5.86,5.86,0,0,1,3.45,10.6l-60.1,43.67a5.85,5.85,0,0,0-2.13,6.56l22.95,70.65a5.85,5.85,0,0,1-9,6.55l-60.11-43.66a5.84,5.84,0,0,0-6.89,0l-60.1,43.66a5.86,5.86,0,0,1-9-6.55l23-70.65a5.88,5.88,0,0,0-2.13-6.56l-60.1-43.67a5.86,5.86,0,0,1,3.44-10.6h74.29a5.87,5.87,0,0,0,5.58-4L531.4,40.47A5.86,5.86,0,0,1,542.55,40.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M276,93.38,299,164a5.84,5.84,0,0,0,5.57,4.05h74.29a5.86,5.86,0,0,1,3.45,10.6l-60.11,43.67a5.85,5.85,0,0,0-2.12,6.55L343,299.56a5.86,5.86,0,0,1-9,6.55l-60.1-43.67a5.87,5.87,0,0,0-6.89,0l-60.1,43.67a5.86,5.86,0,0,1-9-6.55l23-70.66a5.87,5.87,0,0,0-2.13-6.55L158.6,178.68a5.86,5.86,0,0,1,3.45-10.6h74.29a5.84,5.84,0,0,0,5.57-4.05l23-70.65A5.86,5.86,0,0,1,276,93.38Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStoreReviews);
export default __webpack_public_path__ + "static/media/ICON_StoreReviews.b062d252a12a5013eab609b19b1150a3.svg";
export { ForwardRef as ReactComponent };